import { render, staticRenderFns } from "./FootSec.vue?vue&type=template&id=d3230f56&scoped=true&"
import script from "./FootSec.vue?vue&type=script&lang=js&"
export * from "./FootSec.vue?vue&type=script&lang=js&"
import style0 from "./FootSec.vue?vue&type=style&index=0&id=d3230f56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3230f56",
  null
  
)

export default component.exports